import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../components/login/auth.guard';

/**
 * Módulo que possui as rotas que estão dentro CoreModule
 */
const routes: Routes = [
  {
    path: '',
    children: [{
      path: '',
      canActivate: [AuthGuard],
      component: HomeComponent,
      loadChildren: () => import('../features/features.module').then(m => m.FeaturesModule)
    },
    // { path: '**', component: TelaErroComponent, data: { tipo: 'ROTA_INVALIDA' }, },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
